import { EntityModel } from "./entity.model";

export interface LanguageSkillModel extends EntityModel {
    language?: string;
    comprehension?: string;
    speaking?: string;
    writing?: string;
    certification?: any;
}
